"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeZonesList = exports.guessUserTimeZone = exports.getTimeZone = void 0;
var dayjs_1 = __importDefault(require("../dayjs"));
var constants_1 = require("../constants");
var getTimeZone = function (options) {
    var _a;
    return (_a = options === null || options === void 0 ? void 0 : options.timeZone) !== null && _a !== void 0 ? _a : constants_1.UtcTimeZone;
};
exports.getTimeZone = getTimeZone;
/**
 * Returns the user's time zone.
 */
var guessUserTimeZone = function () { return dayjs_1.default.tz.guess(); };
exports.guessUserTimeZone = guessUserTimeZone;
/**
 * Returns all time zones.
 */
// remove when Intl definition is extended
// @ts-expect-error https://github.com/microsoft/TypeScript/issues/49231
var getTimeZonesList = function () { var _a; return ((_a = Intl.supportedValuesOf) === null || _a === void 0 ? void 0 : _a.call(Intl, 'timeZone')) || []; };
exports.getTimeZonesList = getTimeZonesList;
